import "core-js/stable";
import "regenerator-runtime/runtime";

import "@fortawesome/fontawesome-free/css/all.min.css";
import "bootstrap-css-only/css/bootstrap.min.css";
import "mdbvue/lib/mdbvue.css";

import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import VueGtag from "vue-gtag";

Vue.config.productionTip = false;

window.resizeIframe = function() {
  var isInIframe = null;
  try {
    isInIframe = window.self != window.top;
  } catch (e) {
    isInIframe = true;
  }

  if (isInIframe) {
    var appContainer = document.getElementById("app");
    var currentHeight = parseFloat(
      getComputedStyle(appContainer, null).height.replace("px", "")
    );
    parent.postMessage(
      {
        type: "resize",
        height: Math.round(currentHeight)
      },
      "*"
    );
  }
};

window.triggerResize = function() {
  setTimeout(function() {
    window.resizeIframe();
  }, 250);
};

Vue.use(
  VueGtag,
  {
    config: {
      id: "G-QSRFXTN6RQ",
      params: {
        cookie_domain: "cscwebcontent.z8.web.core.windows.net",
        cookie_flags: "SameSite=None;Secure",
        appName: "CSC AWOTE Calculator",
        pageTrackerScreenviewEnabled: true,
        send_page_view: false
      }
    }
  },
  router
);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
